<template>
  <section id="SocialLogin">
    <transition name="fade">
      <div
        class="d-flex justify-content-center align-items-center w-100 flex-xl-row flex-column-reverse bg-white"
      >
        <div>
          <p class="big-title">
            {{ $t('Please wait')+"..." }}
          </p>
          <p class="title">
            {{ $t('Please wait, do not close this window.') }}
          </p>
        </div>
                    
        <img
          :src="imageWaiting"
          alt=""
        >
      </div>  
    </transition>
  </section>
</template>
<script>
export default {
  name: "SocialAccountWaiting",
  data() {
    return {
      imageWaiting:require("@/assets/images/connection_waiting.png"),
    }
  }
}
</script>
<style scoped>
div.validation-invalid-label {
    display: none !important;
}

div.form-group-error>div.validation-invalid-label {
    display: block !important;
}
#SocialLogin .d-flex{
    height: 100vh;
}
#SocialLogin img{
    width: 917px;
}
#SocialLogin p.big-title{
    font-size: 50px;
    font-weight: bold;
}
#SocialLogin p.title{
    font-size: 16px;
}
@media only screen and (max-width: 1024px) {
    #SocialLogin img{
        width: 768px;
    }
    #SocialLogin p.big-title{
        padding-top: 2rem;
    }
}
@media only screen and (max-width: 767px) {
    #SocialLogin img{
        width: 400px;
    }
}
/* fade animate */
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s
}
.fade-enter, .fade-leave-to  {
    opacity: 0
}
/* fade animate */
</style>


// WEBPACK FOOTER //
// src/components/central/public/SocialAccountWaiting.vue